<template>
  <component :is="hasCheckbox ? 'div' : 'a'" class="col-md-12 d-flex px-0" :class="{ highlight: item.isNew }" :href="hasCheckbox ? '' : hrefURL" :target="hasCheckbox ? '' : 'blank'">
    <div class="assign-item d-flex clickable mb-2" @click.stop="emitUpdate">
      <div class="item-image mr-2 align-items-center">
        <div class="item-image-overlay" v-if="!hasCheckbox" v-popover:tooltip.bottom="$t('generals.viewLivePage')">
          <i class="icon icon-view typo-icon-20"></i>
        </div>
        <img :src="itemImg" />
      </div>
      <div class="item-title d-flex">
        <p class="typo-paragraph14 typo-regular text-light-high" v-popover:tooltip.bottom="item.title" @click.stop="emitUpdate">{{ item.title }}</p>
        <div v-if="renderStatus">
          <div class="tag" :class="renderStatus.class">{{ renderStatus.title }}</div>
        </div>
      </div>
      <div v-if="item.template_suffix != '' && hasUnlink" class="align-items-center d-flex item-unlink justify-content-center mx-half" @click.stop.prevent="emitUnlink" v-popover:tooltip.bottom="$t('page.assignment.unlink', { type: $tc(`page.${type.replace('pages', '')}`) })">
        <i class="icon icon-cancel p-1"></i>
      </div>
      <div class="item-checkbox d-flex ml-auto px-1" v-if="hasCheckbox" @click.stop="emitUpdate">
        <label class="checkmark-input" @click.stop="emitUpdate">
          <input type="checkbox" name="checkbox[]" :value="item.id" v-model="item.checked" @click.stop="emitUpdate" />
          <span class="checkmark" @click.stop="emitUpdate"></span>
        </label>
        <div class="fix-click-label"></div>
      </div>
    </div>
  </component>
</template>

<script>
import { mapState } from "vuex";
import { replaceImageToSize } from "@/plugins/shopify.js";

export default {
  name: "AssignListItem",
  props: {
    item: Object,
    type: String,
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    hasUnlink: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    hrefURL() {
      if (this.type == "productpages") {
        return `https://${this.shopInfo.shopifyDomain}/products/${this.item.handle}`;
      }
      return `https://${this.shopInfo.shopifyDomain}/collections/${this.item.handle}`;
    },
    itemImg() {
      let src = this.item && this.item.image && this.item.image.src ? this.item.image.src : "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
      return replaceImageToSize(src, "54x");
    },
    renderStatus() {
      if (this.type == "productpages") {
        const status = (this.item && this.item.status) || "";
        if (!status || ["active"].includes(status)) {
          return "";
        }
        const title = this.capitalizeFirstLetter(status);
        let className = "";
        if (status === "archived") {
          className = "tag-archived";
        }
        return {
          class: className,
          title: title
        };
      } else {
        if (!this.item || !this.item.published_at) {
          return {
            title: "Unavailable"
          };
        }
        return "";
      }
    }
  },
  watch: {},
  created() {},
  methods: {
    capitalizeFirstLetter(string) {
      if (!string) {
        return string;
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    emitUpdate() {
      this.item.checked = !this.item.checked;
      this.$emit("checkedUpdate", {
        id: this.item.id,
        value: this.item.checked
      });
    },
    emitUnlink() {
      if (!this.hasUnlink) return;
      this.$emit("onClickUnAssign", this.item.id);
    }
  }
};
</script>
<style lang="scss" scoped>
// @keyframes highlight {
//   0% {
//     background-color: rgba($accent-green, 0.5);
//   }
//   100% {
//     background-color: white;
//   }
// }
// .highlight {
//   animation: highlight 1000ms ease-out;
// }
.tag {
  color: $textLightModeHigh;
  background: $textDarkModeHigh;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  display: inline-block;
  padding: 1px 4px;
  border-radius: 3px;
  margin-top: 4px;

  &.tag-archived {
    background: $accentAmber100;
    color: $accentAmber500;
  }
}
.assign-item {
  width: 100%;
  user-select: none;
  cursor: pointer;
  // border-bottom: 1px solid $bg;
  @include trans-all;

  .item-checkbox {
    position: relative;
    .fix-click-label {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  .item-unlink {
    i {
      @include trans-all;
      border-radius: $radius;
      color: $textLightModeLow;
    }
    &:hover {
      i {
        color: $accent-red;
      }
    }
  }

  .item-title {
    flex: 1;
    flex-direction: column;
    justify-content: center;
    p {
      max-width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden !important;
      text-overflow: ellipsis;
    }
  }
  .item-image {
    width: 50px;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    .item-image-overlay {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: $light1;
      @include flex-center;
      @include trans-all;

      .icon {
        color: $cPrimary;
        &:focus, &.active, &:active {
          color: $cPrimary;
        }
      }
    }
    img {
      // width: 100%;
      // height: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }

  &:hover {
    background: $light2;

    .item-image-overlay {
      opacity: 1 !important;
    }

    .item-unlink {
      i {
        background: $light1;
      }
    }
  }
}
</style>
